import type { ReactNode, Ref } from "react"
import { cn } from "@/shared/lib/cn"

/**
 * Casca de secao: fundo, respiro vertical e container centralizado.
 *
 * As dez secoes da pagina repetiam a mesma dupla de wrappers
 * (`py-20 lg:py-28` + `max-w-[1280px] mx-auto px-6`). Aqui ela existe uma vez —
 * mudar a largura maxima do site passa a ser uma linha.
 */

export type SectionTone = "off-white" | "white" | "verde"
export type SectionPadding = "lg" | "md" | "none"

const TONES: Record<SectionTone, string> = {
  "off-white": "bg-off-white",
  white: "bg-white",
  verde: "bg-verde-profundo",
}

const PADDINGS: Record<SectionPadding, string> = {
  lg: "py-20 lg:py-28",
  md: "py-16 lg:py-20",
  none: "",
}

export interface SectionProps {
  id?: string
  tone?: SectionTone
  padding?: SectionPadding
  className?: string
  containerClassName?: string
  children: ReactNode
  ref?: Ref<HTMLElement>
  "aria-label"?: string
  "aria-labelledby"?: string
}

export function Section({
  id,
  tone = "off-white",
  padding = "lg",
  className,
  containerClassName,
  children,
  ref,
  ...aria
}: SectionProps) {
  return (
    <section ref={ref} id={id} className={cn(TONES[tone], PADDINGS[padding], className)} {...aria}>
      <div className={cn("max-w-[1280px] mx-auto px-6", containerClassName)}>{children}</div>
    </section>
  )
}
